import { toDisplayString as _toDisplayString, renderSlot as _renderSlot, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  id: "areaInformation"
}
const _hoisted_2 = { class: "tbdc-grid" }
const _hoisted_3 = {
  key: 0,
  class: "tbdc-row"
}
const _hoisted_4 = { class: "text-right" }
const _hoisted_5 = { class: "text-right" }
const _hoisted_6 = {
  key: 0,
  class: "mt-2"
}
const _hoisted_7 = { class: "tbdc-grid" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "text-right" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { key: 2 }
const _hoisted_13 = { class: "text-right" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_PropertyValue = _resolveComponent("PropertyValue")!

  return (_ctx.area != null)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("h2", null, [
          _createTextVNode(_toDisplayString(_ctx.$t("message.areaInformation")), 1),
          _renderSlot(_ctx.$slots, "actions")
        ]),
        _createElementVNode("h3", null, [
          _createTextVNode(_toDisplayString(_ctx.area.areaCode), 1),
          _createVNode(_component_v_btn, {
            icon: "",
            variant: "text",
            disabled: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_icon)
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_2, [
          (_ctx.area.personType)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("div", null, _toDisplayString(_ctx.$t("message.personType")), 1),
                _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.area.personType), 1),
                _cache[0] || (_cache[0] = _createElementVNode("div", null, null, -1))
              ]))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.area.properties, (areaProperty) => {
            return (_openBlock(), _createElementBlock("div", {
              key: areaProperty.name,
              class: "tbdc-row"
            }, [
              _createElementVNode("div", null, _toDisplayString(areaProperty.title), 1),
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_PropertyValue, {
                  property: { roundingDigits: areaProperty.roundingDigits, stringValue: areaProperty.stringValue, numberValue: areaProperty.numberValue, dataType: areaProperty.dataType},
                  onlyCurrentValue: true
                }, null, 8, ["property"])
              ]),
              _cache[1] || (_cache[1] = _createElementVNode("div", null, null, -1))
            ]))
          }), 128))
        ]),
        (_ctx.area.locations != null && _ctx.area.locations.length > 0 && _ctx.scenario.status == 9)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createElementVNode("h4", null, _toDisplayString(_ctx.$t("message.outputType" + _ctx.model.outputType + "Name")) + " / " + _toDisplayString(_ctx.$tc("message.locationsType" + _ctx.model.locationsType + "Name",1)), 1),
              _createElementVNode("div", _hoisted_7, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.area.locations, (locationForArea) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: locationForArea.location.ID,
                    class: "tbdc-row tbdc-hover",
                    onClick: ($event: any) => (_ctx.setLocation(locationForArea.location))
                  }, [
                    _createElementVNode("div", null, [
                      _createVNode(_component_v_icon, null, {
                        default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                          _createTextVNode("mdi-image-filter-center-focus", -1)
                        ]))]),
                        _: 1
                      }),
                      _createTextVNode(" " + _toDisplayString(locationForArea.location.name), 1)
                    ]),
                    _createElementVNode("div", _hoisted_9, [
                      (_ctx.model.outputType == 1)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_10, [
                            _createVNode(_component_PropertyValue, {
                              property: {numberValue: locationForArea.value, dataType: 3},
                              onlyCurrentValue: true,
                              currency: _ctx.model.currency
                            }, null, 8, ["property", "currency"])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.model.outputType == 2)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_11, [
                            _createVNode(_component_PropertyValue, {
                              property: {numberValue: locationForArea.value, dataType: 1, roundingDigits: 0 },
                              onlyCurrentValue: true
                            }, null, 8, ["property"])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.model.outputType == 4)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_12, [
                            _createVNode(_component_PropertyValue, {
                              property: {numberValue: locationForArea.value, dataType: 1, roundingDigits: 0 },
                              onlyCurrentValue: true
                            }, null, 8, ["property"])
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.$filters.percentage((locationForArea.value == 0 ? 0 : (1 / (_ctx.area.totalValue / locationForArea.value))), _ctx.$i18n.locale)), 1)
                  ], 8, _hoisted_8))
                }), 128))
              ])
            ]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}